import React from "react";
import tw, { css } from "twin.macro";
import Grid from "~components/styles/Grid.jsx";
import * as styles from "./styles.module.scss";
import * as T from "~components/styles/Typography.jsx";
import SwiperCarousel from "~components/SwiperCarousel.jsx";

// Helper function to group links into chunks of 10
const groupLinks = (links, size) => {
  const groupedLinks = [];
  for (let i = 0; i < links.length; i += size) {
    groupedLinks.push(links.slice(i, i + size));
  }
  return groupedLinks;
};

const FourColumnLinks = ({ data }) => {
  const { backgroundColor, textColor, header, subheader, links } = data;

  const LINKS_PER_PAGE = 10;
  // Group links into arrays of 10 for mobile view
  const groupedLinks = groupLinks(links, LINKS_PER_PAGE);

  return (
    <section
      css={[
        css`
          background: ${backgroundColor?.hex || `white`};
          color: ${textColor?.hex || `black`};
        `,
        tw`relative block`
      ]}
    >
      <header css={[tw`w-full relative pt-12 md:pt-16 pb-12`]}>
        <T.Head _css={[tw`w-2/3 md:w-full mx-auto mb-4 text-center`]} font="2">
          {header}
        </T.Head>

        <T.Head _css={[tw`w-2/3 mx-auto mt-4 text-center`]} font="4">
          {subheader}
        </T.Head>
      </header>

      {/* Desktop view */}
      <div css={[tw`hidden md:block`]}>
        <Grid _css={[tw`relative pt-3 pb-16 text-center`]}>
          <ul className={styles.grid} css={[tw`col-span-22 col-start-2`]}>
            {links.map((link) => (
              <li key={link._key}>
                <a target="_blank" rel="noreferrer noopener" href={link.url}>
                  <T.Body font="3">{link.text}</T.Body>
                </a>
              </li>
            ))}
          </ul>
        </Grid>
      </div>

      {/* Mobile view */}
      <div css={[tw`md:hidden`]}>
        <SwiperCarousel
          nav={({ current }) => (
            <ul
              css={[
                tw`w-full relative flex items-center justify-center pt-8 pb-12`
              ]}
            >
              {groupedLinks.map((_, index) => (
                <li
                  key={index}
                  css={[
                    css`
                      width: 6px;
                      height: 6px;
                      margin: 0 2px;
                      background: ${`${textColor.hex}`};
                      opacity: ${current === index ? 1 : 0.4};
                    `,
                    tw`relative block rounded-full`
                  ]}
                />
              ))}
            </ul>
          )}
          slides={groupedLinks.map((group, groupIndex) => (
            <div key={groupIndex} css={[tw`w-full relative pt-16 pr-12 pl-12`]}>
              {group.map((link) => (
                <article key={link._key} css={[tw`mb-4`]}>
                  <a target="_blank" rel="noreferrer noopener" href={link.url}>
                    <T.Body _css={[tw`text-center`]} font="2">
                      {link.text}
                    </T.Body>
                  </a>
                </article>
              ))}
            </div>
          ))}
        />
      </div>
    </section>
  );
};

export default FourColumnLinks;
